import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

/* private TermsOfPaymentSettings Types */
import {
  Settings,
  _TermsOfPaymentSettings
} from '../namespace-helper'

import _ from 'lodash'

const selectedTermsOfPaymentTemplate = {
  id: 0,
  name: '',
  days: null,
  description: ''
}
export default {
  namespaced: true,
  state: {
    termsOfPayments: [],
    allTermsOfPayments: [],
    selectedTermOfPayment: _.cloneDeep(selectedTermsOfPaymentTemplate),
    openNewDialog: false
  },
  mutations: {
    [_TermsOfPaymentSettings.mutations.setTermsOfPayments] (state, payload) {
      state.termsOfPayments = payload
    },
    [_TermsOfPaymentSettings.mutations.setAllTermsOfPayments] (state, payload) {
      state.allTermsOfPayments = payload
    },
    [_TermsOfPaymentSettings.mutations.setSelectedTermOfPayment] (state, payload) {
      if (payload !== null) {
        state.selectedTermOfPayment = payload
      } else {
        state.selectedTermOfPayment = {
          id: 0,
          name: '',
          days: null,
          description: ''
        }
      }
    },
    [_TermsOfPaymentSettings.mutations.setOpenCloseNewDialogState] (state) {
      state.openNewDialog = !state.openNewDialog
    }
  },
  actions: {
    [_TermsOfPaymentSettings.actions.saveTermOfPayment] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)

      if (payload.id === 0) {
        var url = API_URL + '/api/v1/termOfPayments'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      } else {
        url = API_URL + '/api/v1/termOfPayments/' + payload.id

        axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      }
    },
    [_TermsOfPaymentSettings.actions.loadTermsOfPayments] (context, payload) {
      console.log('loadTermsOfPayments: ' + JSON.stringify(payload))
      console.log('loadTermsOfPayments: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/termOfPayments?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;name:like;description:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_TermsOfPaymentSettings.mutations.setTermsOfPayments, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_TermsOfPaymentSettings.actions.loadAllTermsOfPayments] (context, payload) {
      var url = API_URL + '/api/v1/termOfPayments'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_TermsOfPaymentSettings.mutations.setAllTermsOfPayments, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_TermsOfPaymentSettings.actions.openCloseNewDialog] ({ commit }) {
      commit(_TermsOfPaymentSettings.mutations.setOpenCloseNewDialogState)
    },
    [_TermsOfPaymentSettings.actions.setSelectedTermOfPayment] ({ commit }, payload) {
      commit(_TermsOfPaymentSettings.mutations.setSelectedTermOfPayment, payload)
    },
    [_TermsOfPaymentSettings.actions.resetState] ({ commit }, payload) {
      commit(_TermsOfPaymentSettings.mutations.setTermsOfPayments, [])
      commit(_TermsOfPaymentSettings.mutations.setAllTermsOfPayments, [])
      commit(_TermsOfPaymentSettings.mutations.setSelectedTermOfPayment, null)
    }
  },
  getters: {
    [_TermsOfPaymentSettings.getters.termsOfPayments] (state) {
      return state.termsOfPayments
    },
    [_TermsOfPaymentSettings.getters.getAllTermsOfPayments] (state) {
      return state.allTermsOfPayments
    },
    [_TermsOfPaymentSettings.getters.getOpenNewDialogState] (state) {
      return state.openNewDialog
    },
    [_TermsOfPaymentSettings.getters.getSelectedTermOfPayment] (state) {
      return state.selectedTermOfPayment
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Settings/termsOfPayments.js